/* The wa.me link for the company number.

   The digits are what WhatsApp accepts, so printed spacing never becomes a
   second number. The footer, the enquiry band, the website report and the
   corner button all call this, so a change of number or of the opening line
   cannot leave one of them behind. The href has to contain `wa.me`: the
   contact tracker classifies a click by that string, and a different host
   would open WhatsApp without recording the contact.

   The opening line follows the page language. A Malay page asks in Malay, so
   the reply can be in Malay. When the visit still has a referral, the line
   names that partner. */

import { commonMessages } from './i18n/common';

const PLAIN = 'Hi there, I would like to know more about your services.';

const REFERRED = 'Hi there, I was referred by {name} and would like to know more about your services.';

export function whatsappHref(phone, locale, referrer) {
    const digits = String(phone || '').replace(/[^0-9]/g, '');
    const text = encodeURIComponent(openingLine(locale, referrer));

    return 'https://wa.me/' + digits + '?text=' + text;
}

function openingLine(locale, referrer) {
    const pack = commonMessages[locale] || commonMessages['en-MY'];
    const name = String(referrer || '').replace(/[\r\n]+/g, ' ').trim();

    if (name === '') {
        return pack[PLAIN] || PLAIN;
    }

    const line = pack[REFERRED] || REFERRED;

    return line.split('{name}').join(name);
}
